import React from 'react';

const Loader = ({ load }) => {
  if (!load) return null;

  return (
    <div className="bwe-fx-wrapper loaderbody" style={{ zIndex: 99999999999 }}>
      <div className="overlay"></div>
      <div className="bwe-fx-container">
        <h1 className="bwe-fx-text" data-text="BWE">BWE</h1>
        <div className="bwe-fx-scanner"></div>
        <div className="bwe-fx-status">Finserv</div>
      </div>
    </div>
  );
};

export default Loader;